import React, { useState, useRef } from "react";
import { MdSend } from "react-icons/md";
import { BiSolidPhoneCall } from "react-icons/bi";
import { FaWpforms } from "react-icons/fa6";
import { Link } from "react-router-dom";
import emailjs from 'emailjs-com';
import Swal from "sweetalert2";
import "../Footer/Footer.css";

const callAdmin = () => {
  window.location.href = 'tel: +919220347091';
};

const Footer = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const formRef = useRef();

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setError(regex.test(value) ? "" : "Enter a valid email address.");
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    validateEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || error) {
      Swal.fire("Oops!", "Please enter a valid email address.", "error");
      return;
    }

    if (!agreed) {
      Swal.fire("Oops!", "Please agree to the terms and privacy policy.", "error");
      return;
    }

    setSending(true);

    emailjs
      .sendForm(
        "service_c2jf13w",
        "template_c34kf4z",
        formRef.current,
        "UxPRjy8Ztmqt2j8Ls"
      )
      .then(() => {
        Swal.fire("Success!", "Thanks for choosing us!", "success");
        setEmail("");
        setError("");
        setAgreed(false);
      })
      .catch(() => {
        Swal.fire("Error", "Something went wrong. Please try again.", "error");
      })
      .finally(() => setSending(false));
  };

  return (
    <footer className="footer">
      <div className="footer-header">
        <div className="top-f">
          <h3>CREATING MEMORABLE EXPERIENCES</h3>
          <h1>Ready to elevate your next event?</h1>
        </div>
        <div className="top-f">
          <p>
            Delivering seamless event planning and conference solutions to ensure your events are impactful and unforgettable.
          </p>
          <div className="footer-buttons">
            <button className="contact-btn" onClick={callAdmin}>
              CONTACT US <BiSolidPhoneCall className="fic" />
            </button>
            <Link to="/contact">
              <button className="get-started-btn">
                GET STARTED <FaWpforms className="fic" />
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="footer-content">
        <div className="footer-section">
          <Link to="/">
            <img src="/shree.png" className="footer-logo" alt="logo-footer" />
          </Link>
          <p>
            Bringing your event vision to life with expert planning, coordination, and execution. Let’s make your next event a success!
          </p>
        </div>

        <div className="footer-section fsf">
          <h4>Explore Pages</h4>
          <ul>
            <Link className="link-t" to="/"><li>Home</li></Link>
            <Link className="link-t" to="/aboutus"><li>About Us</li></Link>
            <Link className="link-t" to="/services"><li>Our Services</li></Link>
            <Link className="link-t" to="/work"><li>Our Work</li></Link>
            <Link className="link-t" to="/contact"><li>Contact Us</li></Link>
          </ul>
        </div>

        <div className="footer-section oef">
          <h4>Our Expertise</h4>
          <ul>
            <li>Live Concerts</li>
            <li>Corporate Events</li>
            <li>Wedding Events</li>
            <li>Social Events</li>
            <li>Full Event Management</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Get Offers & Deals</h4>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={handleChange}
            />
            <button type="submit" disabled={sending}>
              <MdSend />
            </button>
          </form>
          {error && <p className="email-error">{error}</p>}
          <div className="ind">
            <input
              className="in"
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              id="agree"
            />
            <label htmlFor="agree">
              I agree to the terms and <br /> privacy policy.
            </label>
          </div>
        </div>
      </div>

      <div className="footer-ticker">
        <p className="quote">
          "Bringing your events to life, with passion and precision."
        </p>
      </div>

      <div className="footer-bottom">
        <p>
          Copyright © 2025 श्री Var Event & Conference.
          All rights reserved. &nbsp;|&nbsp; Powered by{" "}
          <a
            href="https://infogainsoft.com"
            className="copy-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Infogainsoft
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
